import { ModalContentProps } from "../../types/commonTypes"
import { LNextButton } from "../styled/Button.style"
import { Section } from "../styled/Containers.style"
import { LIconContainer } from "../styled/Icon.style"
import { Vspace } from "../styled/Separators.style"
import { LSimpleText } from "../styled/Text.style"

export const LinearInfoModal = ({ text, additionalImage, close, buttonTxt }: ModalContentProps<null>) => {

    return (
        <>
            <Section linear={true} style={{ marginTop: "32px" }}>
                {additionalImage && <LIconContainer>
                    <img
                        src={additionalImage}
                        alt="Richiesta Aiuto"
                        style={{ width: "120px" }}
                    />
                    <Vspace qty={2}></Vspace>
                </LIconContainer>}
                <LSimpleText className="left">{text}</LSimpleText>
                {additionalImage && <>
                    <Vspace qty={2}></Vspace>
                    <LNextButton onClick={close}>{buttonTxt ? buttonTxt : "Ho capito"}</LNextButton>
                    <Vspace qty={1}></Vspace>
                </>}
            </Section>
        </>
    )
}
